import { ref } from "vue";
import axios from "axios";
import authHeader from "@/Api/AuthHeader";
const URL_API = process.env.VUE_APP_URL_API;

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async addEvent(data) {
      try {
        const resp = await axios.post(URL_API + "events", data, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getAllEvents(page) {
      try {
        const resp = await axios.get(URL_API + "events?page=" + page, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getLastEventInserted() {
      try {
        const resp = await axios.get(URL_API + "getLastEventInserted", {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getLastTenEvent() {
      try {
        const resp = await axios.get(URL_API + "getLastTenEvent", {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getCategories() {
      try {
        const resp = await axios.get(URL_API + `categories`, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getGroups() {
      try {
        const resp = await axios.get(URL_API + `group`, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async getGroupById(id) {
      try {
        const resp = await axios.get(URL_API + `group/${id}`, {
          headers: authHeader(),
        });

        return resp;
      } catch (error) {
        return error;
      }
    },

    async updateGroup(data, id) {
      try {
        let dat = new FormData();

        dat.append("title", data.title);
        dat.append("description", data.description);
        dat.append("id", id);

        const resp = await axios.post(`/api/updateGroup`, dat, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async getMyProduct(user_id) {
      try {
        const resp = await axios.get(URL_API + `getMyProduct/${user_id}`, {
          headers: authHeader(),
        });
        return resp;
      } catch (error) {
        return error;
      }
    },

    async removeProduct(id) {
      try {
        const resp = await axios.get(
          `/Api/api/removeProduct?product_id=${id}`,
          { headers: authHeader() }
        );
        return resp;
      } catch (error) {
        return error;
      }
    },
  },
};
